import React from 'react';

import {Divider, Typography, useTheme} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {ZmSwitch} from 'Components/ZmInputs/index.js';

/**
 * Adding the footer
 * @param {Object} props
 * @return {ReactElement}
 */
export default function DebugFooter(props) {
  const {
    setTroubleShootingMode,
    troubleShootingMode,
  } = props;
  const theme = useTheme();
  const {t} = useTranslation();

  return (
    <footer
      style={{
        position: 'sticky',
        bottom: '-8px',
        backgroundColor: theme.palette.background.default,
      }}>
      <Divider fullWidth/>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        padding: '16px 0',
      }}>

        <Typography sx={{'marginRight': '8px'}}>{t('troubleshoot.showUnavailableTimess')}</Typography>
        <ZmSwitch
          aria-label={'troubleshoot-switch'}
          size="small"
          checked={troubleShootingMode}
          onClick={() => setTroubleShootingMode(!troubleShootingMode)}
        />
      </div>
    </footer>
  );
}
